(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Transparent header on home, product, and about; hero parallax
     runs wherever an MSTT hero is present. Reveal observers run on
     every template that loads this script. */
  const usesOverlayHeader =
    document.body.classList.contains('mstt-home') ||
    document.body.classList.contains('mstt-product-page') ||
    document.body.classList.contains('mstt-about');

  if (usesOverlayHeader) {
    const hero = document.querySelector('.mstt-hero');
    const heroMedia = hero ? document.querySelector('.mstt-hero__media img') : null;
    const threshold = hero ? Math.min(hero.offsetHeight * 0.12, 120) : 80;

    const updateHeader = () => {
      document.body.classList.toggle('mstt-header-scrolled', window.scrollY > threshold);
    };

    const updateHeroParallax = () => {
      if (!heroMedia || reducedMotion) return;
      const offset = Math.min(window.scrollY * 0.28, hero ? hero.offsetHeight * 0.35 : 200);
      heroMedia.style.transform = `scale(1.06) translateY(${offset * 0.15}px)`;
    };

    const onScroll = () => {
      updateHeader();
      updateHeroParallax();
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (reducedMotion) {
    document.querySelectorAll('.mstt-reveal, .mstt-reveal-scale, .mstt-reveal-left, [data-mstt-stagger] > *, [data-mstt-split]').forEach((el) => {
      el.classList.add('is-visible');
      el.classList.add('is-inview');
    });
    return;
  }

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');

        entry.target.querySelectorAll('[data-mstt-stagger] > *').forEach((child, index) => {
          child.style.transitionDelay = `${index * 0.1}s`;
          child.classList.add('is-visible');
        });

        revealObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
  );

  document.querySelectorAll('.mstt-reveal, .mstt-reveal-scale, .mstt-reveal-left').forEach((el) => {
    revealObserver.observe(el);
  });

  const splitObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        splitObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -4% 0px', threshold: 0.15 }
  );

  document.querySelectorAll('[data-mstt-split]').forEach((section) => {
    splitObserver.observe(section);
  });
})();
